import Backdrop from "@mui/material/Backdrop"
import CircularProgress from "@mui/material/CircularProgress"
import { styled } from "@mui/material/styles"
import { useContext } from "react"
import { MapContext } from "./MapContextProvider"

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: 1,
  color: "#fff"
}))

const LoadingMarkers = () => {
  const { loadingMarkers } = useContext(MapContext)

  return (
    loadingMarkers && (
      <StyledBackdrop open={loadingMarkers}>
        <CircularProgress />
      </StyledBackdrop>
    )
  )
}

export default LoadingMarkers
